"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateStorageObjectSchema = exports.AddStorageObjectVersionSchema = exports.StorageObjectWithVersionSchema = exports.StorageObjectVersionBaseSchema = exports.MinimalStorageObjectVersionSchema = exports.StorageObjectSchema = exports.BaseStorageObjectSchema = exports.StorageObjectVersionSchema = exports.BaseStorageObjectVersionSchema = void 0;
const zod_1 = require("zod");
const files_1 = require("./files");
exports.BaseStorageObjectVersionSchema = zod_1.z.object({
    id: zod_1.z.string(),
    storageObjectId: zod_1.z.string(),
    bucketName: zod_1.z.string(),
    objectKey: zod_1.z.string(),
    fileSizeBytes: zod_1.z.number().optional(),
    mimeType: zod_1.z.string().optional(),
    fileExtension: zod_1.z.string().optional(),
    createdOn: zod_1.z.date(),
    version: zod_1.z.number(),
    state: zod_1.z.nativeEnum(files_1.UploadState),
});
exports.StorageObjectVersionSchema = exports.BaseStorageObjectVersionSchema.extend({
    storageObject: zod_1.z.lazy(() => exports.BaseStorageObjectSchema),
});
exports.BaseStorageObjectSchema = zod_1.z.object({
    id: zod_1.z.string(),
    originalFilename: zod_1.z.string(),
    disclosureSubmissionId: zod_1.z.string().optional().nullable(),
    submissionId: zod_1.z.string().optional().nullable(),
    fileType: zod_1.z.nativeEnum(files_1.FileType),
    createdOn: zod_1.z.date(),
    updatedOn: zod_1.z.date().optional(),
});
exports.StorageObjectSchema = exports.BaseStorageObjectSchema.extend({
    versions: zod_1.z
        .array(zod_1.z.lazy(() => exports.BaseStorageObjectVersionSchema))
        .optional()
        .nullable(),
});
exports.MinimalStorageObjectVersionSchema = zod_1.z.object({
    id: zod_1.z.string(),
    fileName: zod_1.z.string(),
    version: zod_1.z.number(),
    createdOn: zod_1.z.date(),
});
exports.StorageObjectVersionBaseSchema = exports.StorageObjectVersionSchema.omit({
    storageObject: true,
});
exports.StorageObjectWithVersionSchema = exports.StorageObjectSchema.omit({
    versions: true,
}).extend({
    version: exports.BaseStorageObjectVersionSchema.nullable().optional(),
});
exports.AddStorageObjectVersionSchema = exports.StorageObjectVersionSchema.omit({
    id: true,
    storageObject: true,
    version: true,
    createdOn: true,
}).extend({
    version: zod_1.z.number().optional().nullable(),
});
exports.CreateStorageObjectSchema = exports.StorageObjectWithVersionSchema.omit({
    id: true,
    createdOn: true,
    updatedOn: true,
}).extend({
    version: exports.AddStorageObjectVersionSchema.extend({
        storageObjectId: zod_1.z.string().optional().nullable(),
    })
        .optional()
        .nullable(),
});
